import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Menu from './Menu'
import Intro from './Intro'
import ArrowUp from './ArrowUp'
import ArrowDown from './ArrowDown'
import Projects from './Projects'
import Publications from './Publications'
import People from './People'
import Contact from './Contact'
import News from './News'
import SeaFloor from './SeaFloor'


const styles = theme => ({
  content: {
    // padding, not margin: a top margin would collapse through the app
    // wrapper and drag the absolutely-positioned header scene down with it
    paddingTop: '100vh',
  },
})


class Content extends React.Component {

  render() {
    const {classes} = this.props
    return (
      <div className={classes.content}>
        <Menu />
        <Intro />
        <ArrowDown />
        <News />
        <Publications />
        <Projects />
        <People />
        <Contact />
        <ArrowUp />
        <SeaFloor />
      </div>
    )
  }
}


export default withStyles(styles)(Content)
